import React, { useState, useRef, useEffect } from 'react'
import { FiChevronDown } from 'react-icons/fi'

export default function BranchSelect({ value, onChange, options, placeholder, width, className }) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [])

  const selected = options.find(o => o.value === value)
  const displayLabel = selected ? selected.label : (placeholder || 'Select...')

  const handleSelect = (val) => {
    onChange({ target: { value: val } })
    setOpen(false)
  }

  return (
    <div className='branch-select-wrapper' ref={ref} style={width ? { width } : undefined}>
      <div className={'branch-select-trigger' + (className ? ' ' + className : '')} onClick={() => setOpen(!open)}>
        <span style={{ color: selected ? 'var(--branch-text)' : '#94a3b8' }}>{displayLabel}</span>
        <FiChevronDown size={14} style={{ transform: open ? 'rotate(180deg)' : undefined, transition: 'transform 0.2s ease', color: 'var(--branch-text-muted)' }} />
      </div>
      {open && (
        <div className='branch-select-dropdown'>
          {options.map(opt => (
            <div
              key={opt.value}
              className={'branch-select-option' + (opt.value === value ? ' selected' : '')}
              onClick={() => handleSelect(opt.value)}
            >
              <span>{opt.label}</span>
              {opt.value === value && (
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style={{ flexShrink: 0 }}>
                  <path d="M11.667 3.5L5.25 9.917L2.333 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
